module.exports = [
  require('./fire_giant_dreadnought'),
  require('./firenewt_warlock_of_imix'),
  require('./firenewt_warrior'),
  require('./flail_snail'),
  require('./flind'),
  require('./froghemoth'),
  require('./frost_giant_everlasting_one'),
]
